import { useCallback, useMemo, useState } from "react";

const storageKey = (projectId: string, notice: string) =>
  `rivetai:project-notice-dismissed:${notice}:${projectId}`;

const readDismissed = (key: string | null): boolean => {
  if (!key || typeof window === "undefined") return false;
  try {
    return window.localStorage.getItem(key) === "true";
  } catch {
    return false;
  }
};

export const useProjectNoticeDismissal = (projectId: string, notice: string) => {
  const key = projectId ? storageKey(projectId, notice) : null;
  const [dismissedKey, setDismissedKey] = useState<string | null>(null);
  const dismissed = useMemo(() => dismissedKey === key || readDismissed(key), [dismissedKey, key]);

  const dismiss = useCallback(() => {
    if (!key || typeof window === "undefined") return;
    try {
      window.localStorage.setItem(key, "true");
    } catch {
      // Keep the dismissal in memory when browser storage is unavailable.
    }
    setDismissedKey(key);
  }, [key]);

  return { dismissed, dismiss };
};
